import { ChangeDetectorRef,Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { SelectionService } from '../../../../../services'
import { AtylService } from '../../../../service/atyl.service'
import { InputLabelPipe } from '../../../../../pipes/atyl/inputLabel.pipe'
import { FormAtylBase,ForAtylInputBase } from '../../../../form-atyl-base'

import { Subject } from 'rxjs/internal/Subject'
import { debounceTime, first } from 'rxjs/operators'

@Component({
	selector: 'atyl-form-input-dropdown',
	templateUrl: './form-input-dropdown.component.html',
	styleUrls: ['./form-input-dropdown.component.scss']
})
export class FormInputDropDownComponent extends ForAtylInputBase  implements OnInit {

	@Input() forminput: FormAtylBase<any>
	@Input() group: any
	@Input() isValid: boolean
	@Input() errorMessage: any
	@Input() disabled: boolean

	@Output() inputTyped = new EventEmitter<any>()
	label: string
	errorString: string
	@Input() outline: any

	private debounce: Subject<string> = new Subject();

	constructor(
		private readonly cdr: ChangeDetectorRef,
		private listService: SelectionService,
		private readonly inputLabelPipe: InputLabelPipe,
		private atylService: AtylService,
		
	) {
		super();
		
	}

	ngOnInit(): void {
        console.log('init FormInputDropDownComponent',this.forminput,
        this.disabled);
		// get options list from webservice
		/*
		{
			    "typelist": "Ecole",
			    "fields": {
			        "value":"id",
			        "label":["tiers.tiersMorale.nom",
			                    "tiers.tiersAdresse.0.adresse.ville.libelle"]
			    },
			    "values":[]
			}
		*/
		
		if (this.forminput.options["value"]!=undefined) {
				console.log("FormInputDropDownComponent options vlaue",this.forminput.options)
				this.group.get(this.forminput.ID).setValue(this.forminput.options["value"]);
			}  
		
		if (this.forminput 
			&& this.forminput.options['typelist']!=undefined
			&& this.forminput.options['fields']!=undefined
		) {
			console.log("FormInputDropDownComponent list",
			this.forminput.options['typelist'],
			this.forminput.options['fields']
			);
			
			let _ops={}
			
			if (this.forminput.options['options'])
			    _ops=this.forminput.options['options'];
			    
			  
			    
			if (
				this.forminput.options.autocomplete!=undefined 
				&& this.forminput.options.autocomplete 
				&& this.forminput.value!=undefined 
				&& this.forminput.value) {
			    	_ops["ids"]=[this.forminput.value];
			 }   
			 this.emitReadyEvent(false,this.forminput);
			this.atylService.getListeSelectionOPtion(this.forminput.options['typelist'], _ops).subscribe((res: JSONRpcResponse) => {
				//console.log("FormInputDropDownComponent list result",res.result);
				if (res.result.datas!=undefined && res.result.datas.datas!=undefined) {
					let lines=res.result.datas.datas;
					if (lines.length>0
						&& this.forminput.options['fields']["value"]!=undefined
					) {
						let col_val:string="id"
						if (this.forminput.options['fields']["value"]!=undefined)
							col_val=this.forminput.options['fields']["value"];
						let cols_label:string[] =["label"]
						if (this.forminput.options['fields']["label"]!=undefined)
							cols_label=this.forminput.options['fields']["label"];	
						//console.log("FormInputDropDownComponent  result parse",col_val,cols_label,lines)
						for(let i=0;i<lines.length;i++) {
							let l=lines[i];
							let val={
								value:null,
								label:null
							}
							if (l[col_val]!=undefined)
							    val["value"]=l[col_val];
							if (this.forminput.options['fields']["template"]!=undefined) {
								
								let tpl:string=this.forminput.options['fields']["template"];
								for(let lb=0;lb<cols_label.length;lb++) {
									if (l[cols_label[lb]]!=undefined)
								    	tpl=tpl.replace("{{"+cols_label[lb]+"}}", l[cols_label[lb]]);
								    else
								    	tpl=tpl.replace("{{"+cols_label[lb]+"}}", "");
								}
								val["label"]=tpl;
							} else {
								let lbs:any[]=[];
								for(let lb=0;lb<cols_label.length;lb++) {
									if (l[cols_label[lb]]!=undefined)
								    	lbs.push(l[cols_label[lb]]);
								}
								val["label"]=lbs.join(" ");
							}
							this.forminput.options.values.push(val)
							this.emitReadyEvent(true,this.forminput);
						}
						console.log("FormInputDropDownComponent  result",
						res.result,
						this.forminput)
								
						if (this.forminput.options.autocomplete!=undefined 
						&& this.forminput.options.autocomplete
						&& this.forminput.value!=undefined) {
							let selectedLabel=null;
							this.forminput.options.values.forEach((select) => {
								//console.log('displayAutoList',select,key);
								if ( select.value!=undefined &&
									select.label!=undefined &&
									 select.value+'' === this.forminput.value + '')  {
										this.group.get(this.forminput.ID).setValue(select.value);
										
									} 
							})
							/*console.log("FormInputDropDownComponent  label",
									selectedLabel)
							if (selectedLabel!=null)
							   this.forminput.value=selectedLabel*/
							 
						}
						
						this.cdr.detectChanges(); 
				    }
				}
				
				this.emitReadyEvent(true,this.forminput);
			})
		}
		
		
		this.label = this.inputLabelPipe.transform(this.forminput)
		// error message
		this.errorString = this.errorMessage && this.errorMessage[0] ? this.errorMessage[0] : ''
		
		this.debounce.pipe(debounceTime(1000)).subscribe((search) => {
		if (search.length > 0) {
					if (this.forminput 
				&& this.forminput.options['typelist']!=undefined
				&& this.forminput.options['fields']!=undefined
				) {
					console.log("FormInputDropDownComponent list",
					this.forminput.options['typelist'],
					this.forminput.options['fields']
					);
					this.forminput.options.values=[];
					let _ops={
						"filters": {
							"search": {
								"value": search
							}
						}
						
					}
					
					if (this.forminput.options['options'])
					    _ops=this.forminput.options['options'];
					this.emitReadyEvent(false,this.forminput);
					this.atylService.getListeSelectionOPtion(this.forminput.options['typelist'], _ops).subscribe((res: JSONRpcResponse) => {
						//console.log("FormInputDropDownComponent list result",res.result);
						if (res.result.datas!=undefined && res.result.datas.datas!=undefined) {
							let lines=res.result.datas.datas;
							if (lines.length>0
								&& this.forminput.options['fields']["value"]!=undefined
							) {
								let col_val:string="id"
								if (this.forminput.options['fields']["value"]!=undefined)
									col_val=this.forminput.options['fields']["value"];
								let cols_label:string[] =["label"]
								if (this.forminput.options['fields']["label"]!=undefined)
									cols_label=this.forminput.options['fields']["label"];	
								//console.log("FormInputDropDownComponent  result parse",col_val,cols_label,lines)
								for(let i=0;i<lines.length;i++) {
									let l=lines[i];
									let val={
										value:null,
										label:null
									}
									if (l[col_val]!=undefined)
									    val["value"]=l[col_val];
									let lbs=[];
									for(let lb=0;lb<cols_label.length;lb++) {
										if (l[cols_label[lb]]!=undefined)
									    	lbs.push(l[cols_label[lb]]);
									}
									val["label"]=lbs.join(" ");
									this.forminput.options.values.push(val)
									this.emitReadyEvent(true,this.forminput);
								}
								console.log("FormInputDropDownComponent  result",
								res.result,
								this.forminput)
								
								if (this.forminput.options.autocomplete!=undefined 
									&& this.forminput.options.autocomplete
									&& this.forminput.value!=undefined) {
										let selectedLabel=null;
										this.forminput.options.values.forEach((select) => {
											//console.log('displayAutoList',select,key);
											if ( select.value!=undefined &&
												select.label!=undefined &&
												 select.value+'' === this.forminput.value + '')  {
													this.group.get(this.forminput.ID).setValue(select.value);
													
												} 
										})
										/*console.log("FormInputDropDownComponent  label",
												selectedLabel)
										if (selectedLabel!=null)
										   this.forminput.value=selectedLabel*/
										 
								}
								this.cdr.detectChanges();     
								
						    }
						}
						this.emitReadyEvent(true,this.forminput);
					})
				}	
			}
		})
	}
	
	triggerAutocompList(search: any) {
		console.log('triggerAutocompList',search);
		this.debounce.next(search);
	}

	displayAutoList(key?: any): string | undefined {
		let selected
		if (this.forminput.options.values) {
			
			this.forminput.options.values.forEach((select) => {
				//console.log('displayAutoList',select,key);
				if ( select.value!=undefined &&
					 select.value+'' === key + '')  selected = select
			})
		}
		return selected ? selected.label : undefined
	}
	
	selectedAutoOption(event:any) {
	   const selectedValue = event.option.value;
	  /* this.forminput.value=selectedValue;*/
	   console.log(selectedValue,this.forminput);
	}
}
